import type {
  ClientOrganizationProfile,
  ClientPostTypeEnum
} from '@DigitaleDoerfer/digitale-doerfer-api';

import type { SenderType } from '@/features/sender-selection/types/sender';

export const PostCreationContext = {
  MEIN_ORT: 'MEIN_ORT',
  MEINE_REGION: 'MEINE_REGION',
  GRUPPE: 'GRUPPE',
  SAGS_UNS: 'SAGS_UNS'
} as const;

export type PostCreationContext =
  (typeof PostCreationContext)[keyof typeof PostCreationContext];

export type PostCreationChannelType =
  | 'GOSSIP'
  | 'NEWS_ITEM'
  | 'SUGGESTION'
  | 'MARKET'
  | 'HAPPENING'
  | 'SPECIAL_POST';

export type PostCreationChannelOption = {
  channelType: PostCreationChannelType;
  orderValue: number;
  postTypes: ClientPostTypeEnum[];
};

export type SenderPostCreationOption = {
  senderType: SenderType;
  organization?: ClientOrganizationProfile | null;
  channels: PostCreationChannelOption[];
};

export type PostCreationOptions = {
  creationContext: PostCreationContext;
  senders: SenderPostCreationOption[];
};
